var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFemaleWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98652 12.2274C9.97634 11.815 12.2867 9.24454 12.2867 6.14335C12.2867 2.75583 9.53086 0 6.14335 0C2.75583 0 0 2.75583 0 6.14335C0 9.24454 2.31035 11.815 5.30017 12.2274V15.3785H1.40544V17.0648H5.30017V21H6.98652V17.0648H10.8813V15.3785H6.98652V12.2274ZM1.68646 6.14335C1.68646 3.68583 3.68583 1.68646 6.14335 1.68646C8.60086 1.68646 10.6002 3.68583 10.6002 6.14335C10.6002 8.60086 8.60086 10.6002 6.14335 10.6002C3.68583 10.6002 1.68646 8.60086 1.68646 6.14335Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFemaleWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/female_white.1ee1f78547ff6761a850f675dcf1bcae.svg";